<template>
  <info-card :title="$t('VG/PG Ratio')">
    <div class="d-flex mt-n5">
      <v-checkbox
        v-model="searchParams.selectedPgVgRatios"
        hide-details
        label="High VG"
        multiple
        value="high_vg"
        @change="onChange"
      />
      <v-checkbox
        v-model="searchParams.selectedPgVgRatios"
        class="ml-5"
        hide-details
        label="50/50"
        multiple
        value="50_50"
        @change="onChange"
      />
      <v-checkbox
        v-model="searchParams.selectedPgVgRatios"
        class="ml-5"
        hide-details
        label="High PG"
        multiple
        value="high_pg"
        @change="onChange"
      />
    </div>
  </info-card>
</template>

<script>
import InfoCard from '@/components/InfoCard'
// import attributeService from '@/services/attributes'
export default {
  name: 'PgVgFilter',
  components: {
    InfoCard
  },
  data: () => ({
    // allPgVgRatios: [],
    pgVgRatioInput: '',
    searchParams: {
      selectedPgVgRatios: []
    }
  }),
  // mounted () {
  //   // Get all pg_vg_ratios to use in autocomplete
  //   attributeService.attributeOptionsByCode('pg_vg_ratio')
  //     .then(data => { this.allPgVgRatios = data.data.options })
  //     .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
  // },
  methods: {
    onChange () {
      this.$emit('change', this.searchParams)
    },
    reset () {
      this.searchParams = {
        selectedPgVgRatios: []
      }
      this.onChange()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vapevault/filters/PgVgFilter.vue